if (!customElements.get('intersection-caller')) {
    class IntersectionCaller extends HTMLElement {
        constructor() {
            super();
        }

        EventUnSubscriber = undefined;

        connectedCallback() {
            this.Initialize()
        }
        disconnectedCallback() {
            if (this.EventUnSubscriber) {
                this.EventUnSubscriber();
            }
        }
        Initialize() {
            this.IntersectionID = this.dataset.intersectionCaller
            this.Handler = this.closest(`[data-intersection-handler="${this.dataset.intersectionCaller}"]`);
            
            this.DebouncedScroll = debounce((event) => {
                this.HandleScroll(event);
            }, 100);
            document.addEventListener('scroll', this.DebouncedScroll.bind(this))

            this.EventUnSubscriber = SubscribeToEvent(`Intersection-${this.IntersectionID}`, (eventData) => {
                this.OnEvent(eventData)
            });
        }
        HandleScroll() {
            if(this.dataset.state==='loading') return
            if(this.ElementInViewport()) {
                this?.Handler?.HandleIntersection?.()
            }
        }
        ElementInViewport() {
            const rect = this.getBoundingClientRect();
        
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        OnEvent(EventData) {
            this.dataset.state = EventData?.state ? EventData.state : 'done'
        }
    }

    customElements.define('intersection-caller', IntersectionCaller);
}